import { useNavigate } from "react-router-dom";
import BG_MAIN from "../assets/bg-main.png";
import { Button, Select, MenuItem, } from "@mui/material";
import { useClientContext } from "../context/ClientContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Footer from "../components/Footer";
import { clientGroups } from '../assets/clientData';
import axiosInstance from "../utils/axios";
import { useLoading } from "../context/LoadingContext";

function HomePage() {
  const navigate = useNavigate();
  const { clientName, setClientName, clientGroup, setClientGroup } = useClientContext();
  const { showLoading, hideLoading } = useLoading();

  const handleClientChange = (event) => {
    //console.log('client name', event.target.value);
    //setClientName(event.target.value);
    setClientGroup(event.target.value);
  };

  const handleExplore = async () => {
    try {
      showLoading();
      const response = await axiosInstance.post("/populate_dashboard", {
        client_id: clientGroup,
        subsidiary: ""
      });
      
      if (response.data) {
        navigate("/clientInsights");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      hideLoading();
    }
  };

  return (
    <div
      className="relative flex items-center justify-start h-[90vh] bg-cover bg-center"
      style={{
        backgroundImage: `url(${BG_MAIN})`,
      }}
    >
      {/* Left Content */}
      <div className="w-[70%] p-24">
        <div className="p-4">
          <h2 className="font-bold text-xl mb-6 text-[#F15A23]">RM 360°</h2>
          <p className="font-bold mb-6 text-md">
            RM 360° provides a comprehensive outside in view on a client and
            industry trends, leveraging internal as well as publicly available
            data.​
          </p>
          <p className="mb-4 text-sm">
            It enables quick identification of client's priorities and
            opportunity​ areas across different categories for client viz-a-viz
            their peers/overall market
          </p>

          <div className="text-sm font-bold mb-2" style={{ color: '#6C757D' }}>Client/Client Group</div>
          <div className="flex gap-6">
            <Select
              value={clientGroup}
              size="small"
              sx={{
                minWidth: "12rem",
                fontSize: "12px",
                //color: "white",
                "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Removes the default outline
                "& .MuiSelect-icon": { color: "#00555C" }, // Arrow color
                borderBottom: '1px solid',
                borderRadius: '0px'
              }}
              IconComponent={ExpandMoreIcon}
              onChange={handleClientChange}
            >
              {clientGroups.map((group) => (
                  <MenuItem key={group.group_name} value={group.group_name}>
                    {group.group_name}
                  </MenuItem>
                ))}
            </Select>
            <Button
              sx={{
                color: "white",
                width: "150px",
                borderRadius: "24px",
                height: "32px",
                backgroundColor: "#00555C", // Lighter color for disabled
                "&:hover": {
                  backgroundColor: "#004649", // Slightly darker on hover
                },
              }}
              onClick={handleExplore}
            >
              Explore
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
